import { createFileRoute } from "@tanstack/react-router";
import { AvisoPrivacidadePage } from "@/components/pages/AvisoPrivacidadePage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Privacy Notice and Data Protection — Kentro",
    desc: "Kentro Sistemas Privacy Notice under Brazil's LGPD: data collected, purposes, sharing, security, retention and data subject rights.",
    ogTitle: "Privacy Notice and Data Protection — Kentro",
    ogDesc: "Complete personal data protection document from Kentro under the LGPD.",
  },
  es: {
    title: "Aviso de Privacidad y Protección de Datos — Kentro",
    desc: "Aviso de Privacidad de Kentro Sistemas conforme a la LGPD: datos recopilados, finalidades, compartición, seguridad, retención y derechos del titular.",
    ogTitle: "Aviso de Privacidad y Protección de Datos — Kentro",
    ogDesc: "Documento completo de protección de datos personales de Kentro conforme a la LGPD.",
  },
} as const;

export const Route = createFileRoute("/$locale/aviso-de-privacidade")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/aviso-de-privacidade` },
        { property: "og:locale", content: loc === "es" ? "es_ES" : "en_US" },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/aviso-de-privacidade` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/aviso-de-privacidade` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/aviso-de-privacidade` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/aviso-de-privacidade` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/aviso-de-privacidade` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Aviso de Privacidade', item: `${SITE}/${loc}/aviso-de-privacidade` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/aviso-de-privacidade`,
            url: `${SITE}/${loc}/aviso-de-privacidade`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: AvisoPrivacidadePage,
});
